// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("ChatRateLimit", {
  userId: __t.u64(),
  lastMessageAt: __t.u64(),
  lastMessageHash: __t.u64(),
  spamStrikes: __t.u32(),
  mutedUntil: __t.u64(),
});


